<template>
  <el-dialog :title="mytitle" :visible.sync="dialogFormVisible" custom-class="list-dialog1256" center :append-to-body="true"
             :close-on-click-modal="false">
    <div class="search-content write-order">
        <el-col :span="24" class="toobar">
          <!--<el-tag v-for="item in pingpaiLens" style="margin-right: 6px;cursor: pointer;margin-bottom: 3px" :class="item.type=='danger'?'el-tag&#45;&#45;danger':'el-tag&#45;&#45;info'"-->
                    <!--:key="item.categorycode" @click="selectLens(item.categorycode)">{{item.categoryname}}</el-tag>-->
          <el-form :model="form" ref="form1" label-width="70px" size="mini" :inline="true">
            <el-form-item label="型号">
              <el-input v-model="form.name" auto-complete="off" style="width: 120px"></el-input>
            </el-form-item>
            <el-form-item v-for="(item,index) in queryproperty" :label="item.name" :key="index">
              <el-select  v-model="item.value" placeholder="请选择" style="width: 120px">
                <el-option label="" value=""></el-option>
                <el-option v-for="x in item.items"
                           :key="x" :label="x" :value="x">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary" size="mini" icon="el-icon-search" @click="selectLens">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="16">
          <div class="goodscontent">
            <el-col :span="12" v-for="(item, index) in goodsLens" :key="item.seedcode" style="margin-bottom: 20px">
              <el-card  style="width: 350px;text-align: center;margin-left: 20px">
                <el-image :src="item.advertisementpicture" fit="fit" style="width: 300px;height: 300px;border-width: 1px;border-color: gainsboro">
                </el-image>
                <div style="padding: 4px;float: left;width:96%;text-align: left">
                  <span>{{item.seedname}}</span>
                  <div class="bottom clearfix">
                    <div style="float: left;color: #df102a">￥<span style="font-size: larger"><b>{{ item.pcostprice }}</b></span></div>
                    <el-button style="float: right" type="text" class="button" size="mini" @click="showdetail(item)">查看详情</el-button>
                  </div>
                </div>
              </el-card>
            </el-col>
          </div>
        </el-col>
        <el-col :span="8">
          <el-table
            :data="Shopping"
            size="mini"
            stripe
            border
            style="width: 100%;">
            <el-table-column
              prop="showname"
              label="已选购商品"
              align="left"
              header-align="center">
            </el-table-column>
            <el-table-column
              prop="number"
              label="数量"
              align="left"
              header-align="center"
              width="100">
            </el-table-column>
            <el-table-column
              label=""
              align="center" width="80">
              <template slot-scope="scope">
                <i class="el-icon-shopping-cart-full" style="cursor: pointer" @click="showdetail(scope.row)"></i>
              </template>
            </el-table-column>
          </el-table>
          <div style="width: 100%;float: left" v-if="Shopping.length>0">
            <div style="float: left;width: 50%;margin-top: 50px;padding-left: 10px"><span>共 </span><span style="color: #df102a;font-size: larger"><b>{{totalNum}}</b></span><span> 副</span>
              <span style="padding-left: 30px">￥</span><span style="color: #df102a;font-size: larger"><b>{{totalMoney}}</b></span></div>
          <el-button type="primary" @click="ShopOver()" size="mini" style="margin-right: 20px;float: right;margin-top: 50px" :loading="loading">选购完成</el-button>
          </div>
        </el-col>
    </div>
    <el-drawer
      :title="goodsdetail?goodsdetail.seedname:''"
      :visible.sync="drawerVisible"
      direction="rtl" :append-to-body="true">
      <div class="goodsdrawer">
        <el-divider content-position="center">选择色号</el-divider>
        <el-form :model="formcolor" ref="form2" label-width="140px" size="mini" :inline="true">
          <el-form-item v-for="(item,index) in goodsframe" :label="item.showname" :key="index">
            <el-input-number v-model="item.number" :controls="true" size="mini" style="width: 110px" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="" style="text-align: center">
            <el-button type="primary" size="mini" icon="el-icon-shopping-cart-full" style="margin-left: 50px" @click="add2Shop">加入购物车</el-button>
          </el-form-item>
        </el-form>
        <el-divider content-position="center">产品详情</el-divider>
        <div v-html="goodsdetail?goodsdetail.description:''" style="width: 100%"></div>
      </div>
    </el-drawer>
  </el-dialog>
</template>
<script>
  import {getGoodsTree,getListfixcilumn} from '@/api/set/jxcgooddetail';
  import {supplyCategory,supplyGoods,supplyGoodsdetail} from '@/api/ossi';

  import {loadSpecFrame} from '@/plugin/ordercommon';
  import {jingjiaupload} from '@/api/set/jxcgooddetail'


  export default {
    name: 'SupplyShop',
    data() {
      return {
        msg: '供应商商城',
        drawerVisible:false,
        dialogFormVisible: false,
        form:{
          name:'',
          categorycode:'',
          query:'',
        },
        formcolor:{

        },
        page:{
          limit:500,
          offset:0,
        },
        ssotoken:'',
        searchdata: "",
        mytitle: '',
        tableData: [],
        goodsLens:[],
        shoppingLens:[],
        queryproperty:[],
        Shopping:[],
        goodsdetail:{},
        goodsframe:[],
        coupon: '',
        pcustomer:'',
        totalNum:0,
        totalMoney:0,
        categorycode:'',
        loading:false,
      }
    },
    methods: {
      initData(ssotoken, categorycode, categoryname, pcustomer) {
        this.loading=false;
        this.ssotoken = ssotoken;
        this.pcustomer=pcustomer;
        this.categorycode=categorycode;
        this.mytitle = pcustomer+' 品牌库';
        this.goodsdetail = null;
        this.dialogFormVisible = true;
        this.Shopping = [];
        this.goodsLens = []
        this.form.categorycode='';

        supplyCategory({
          tenantid: "",
          canshowallcat: "true",
          category: categorycode.substr(0, 3),
          categorynamefix: categoryname
        }, this.ssotoken).then(response => {
          if (response.data.code != 0 || response.data.obj.rows.length == 0)
            return;

          var categoryInfo = response.data.obj.rows[0];//取第一个符合条件的品牌

          this.form.name = ''
          this.queryproperty = []

          //分类、商品
          if (categoryInfo.queryproperty) {
            var qp = JSON.parse(categoryInfo.queryproperty);
            for (let j in qp) {
              var hasValue = false;
              for (let hset in this.queryproperty) {
                if (this.queryproperty[hset].name == qp[j].name) {//参数已存在
                  hasValue = true;
                  this.queryproperty[hset].items = this.setItems(this.queryproperty[hset].items, qp[j].item.split(';'));
                  break;
                }
              }

              if (!hasValue && qp[j].item) {
                this.queryproperty.push({
                  name: qp[j].name,
                  value: '',
                  items: this.setItems([], qp[j].item.split(';'))
                })
              }
            }
          }
          this.form.categorycode = categoryInfo.categorycode;
          this.selectLens();
        })
      },
      removeShopp(index) {
        this.Shopping.splice(index, 1);
      },
      checkTable(row) {
        this.seedcode = row.seedcode
        this.seedname = row.seedname
        this.filltemplate = row.filltemplate
      },
      setItems(item, newItem) {
        for (let i in newItem) {
          var hasV = false;
          for (let j in item) {
            if (newItem[i] == item[j]) {
              hasV = true;
              break;
            }
          }
          if (!hasV && newItem[i]) {
            item.push(newItem[i]);
          }
        }
        return item;
      },
      selectQuery(item, o) {
        item.value = o;
        this.showTable();
      },
      showTable() {
        var index = 0;
        for (let i in this.goodsLens) {
          var data = this.goodsLens[i]
          data.isshow = false;
          if (index > 110)
            continue;

          if (!this.form.category || data.categorycode == this.form.category) {
            data.isshow = true;
          }
          if (data.isshow) {
            for (let j in this.queryproperty) {
              if (this.queryproperty[j].value) {
                if (!data.queryproperty.includes('{"name":"' + this.queryproperty[j].name + '","item":"' + this.queryproperty[j].value + '"}')) {
                  data.isshow = false;
                  break;
                }
              }
            }
          }
          if (data.isshow)
            index++;
        }
      },
      selectLens() {
        var arr = [];
        for (let i in this.queryproperty) {
          if (this.queryproperty[i].value) {
            arr.push({name: this.queryproperty[i].name, item: this.queryproperty[i].value})
          }
        }
        if (!this.form.categorycode) return;
        supplyGoods({
          filltemplates: 80,
          categorycode: this.form.categorycode,
          enable: 1,
          seedname: this.form.name,
          offset: this.page.offset,
          limit: this.page.limit,
          showprice: "storev",
          querys: JSON.stringify(arr)
        }, this.ssotoken).then(response => {
          this.goodsLens = response.data.obj.rows
          // this.showTable();
        }).catch((error) => {
          console.log(error)
        })
      },
      showdetail(item) {
        supplyGoodsdetail({
          seedcode: item.seedcode
        }, this.ssotoken).then(response => {
          this.drawerVisible = true;
          this.goodsdetail = response.data.obj
          if (this.goodsdetail.description) {
            this.goodsdetail.description = this.goodsdetail.description.replace(new RegExp("<img ", "gm"), "<img style='width:100%' ");
          }
          this.goodsframe = [];
          var frame = JSON.parse(this.goodsdetail.goodsframe);
          for (let i in frame) {
            var colorArr = frame[i].color.split(';');
            for (let j in colorArr) {
              var color = colorArr[j]
              if (color) {
                var row = {
                  M: frame[i].model,
                  C: color,
                  price: this.goodsdetail.prices[0].costprice,
                  seedcode: frame[i].seedcode,
                  showname: frame[i].model + " - " + color,
                  seedname:this.goodsdetail.seedname,
                  number: 0
                };
                row.number = this.getShoppingvalue(row);
                this.goodsframe.push(row);
              }
            }
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      getShoppingvalue(row) {
        for (let i in this.Shopping) {
          if (this.Shopping[i].seedcode == row.seedcode && this.Shopping[i].M == row.M && this.Shopping[i].C == row.C)
            return this.Shopping[i].number;
        }
        return undefined;
      },
      add2Shop() {//加入购物车
        var newArr = [];
        for (let i in this.goodsframe) {
          if (this.goodsframe[i].number > 0) {
            newArr.push(this.goodsframe[i]);
          }
        }
        for (let i in this.Shopping) {
          if (this.Shopping[i].seedcode == this.goodsdetail.seedcode)
            continue;
          newArr.push(this.Shopping[i]);
        }

        this.totalNum = 0;
        this.totalMoney = 0;
        for (let i in newArr) {
          this.totalNum += parseInt(newArr[i].number);
          this.totalMoney += parseFloat(newArr[i].number) * parseFloat(newArr[i].price);
        }
        this.totalMoney=this.totalMoney.toFixed(2);
        this.Shopping = newArr;
        this.drawerVisible = false;
      },
      ShopOver() {
        var addTable = [];

        for (let i in this.Shopping) {
          var item = this.Shopping[i];
          addTable.push({
            "型号": item.M, "规格": item.C, "数量": item.number, "商品名称": item.seedname,
            "供应商": this.pcustomer, "采购成本价": item.price
          });
        }
        if (addTable.length == 0) {
          return;
        }
        let arr = loadSpecFrame(addTable, this.categorycode, "", null);

        this.loading = true;

        jingjiaupload({needcode: 1, arr: JSON.stringify(arr)}).then(resPrice => {
          this.loading = false;
          if (resPrice.data.code != 0) {
            return;
          }

          var returnSeed = resPrice.data.obj;
          if (returnSeed == null) return;

          var returnData = [];
          for (let i in arr) {
            var item = arr[i];
            var frameT = JSON.parse(item.goodsframe)[0];
            returnData.push({
              seedcode: returnSeed.find(row => row.goodsframe == item.goodsframe).seedcode,
              seedname: item.seedname,
              color: frameT.color,
              model: frameT.model,
              categorycode: this.categorycode,
              totalnumber: item.minnumber
            });
          }
          this.$emit('afterSelect', returnData);
          this.dialogFormVisible = false;
        });
      }
    },
    mounted() {
    },
    components: {
    }

  }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.goodscontent{
  width: 100%;
  float: left;
  height: calc(96vh - 189px);
  overflow: auto;
}

.goodsdrawer{
  width: 100%;
  float: left;
  height: calc(96vh - 50px);
  overflow: auto;
}



</style>




// WEBPACK FOOTER //
// src/components/testorder/buyagreement/SupplyShop.vue